export default __webpack_public_path__ + "static/media/farmer.10c4f974.jpeg";